import { UnidadNegocio } from 'src/app/domain/model/agenda/agenda';
import { PageResponse } from 'src/app/domain/model/common/page-response.dto';

/** Dirección de la paginación keyset del backend. */
export type DireccionUnidadNegocio = 'NEXT' | 'PREVIOUS' | 'LAST';

/**
 * Puerto (interface) del dominio para operaciones con Unidades de Negocio
 *
 * Define el contrato que debe implementar cualquier adaptador
 * de infraestructura (HTTP, Mock, etc.)
 *
 * Legacy: FilterUnidadNegocioViewImpl.java
 * Tabla: TPSC_UNIDADES_NEGOCIO
 * Usado para tipo de cita CONTENIDOS_TECNICOS (54)
 *
 * Consumido desde servicios-ms (no agenda-ms). Ambas consultas se paginan en el
 * servidor con keyset/cursor: size obligatorio (máx. 100), cursor opaco y direction.
 *
 * @author Emerson Rodriguez - Ingeneo
 */
export abstract class UnidadNegocioRepository {

  /**
   * Página de unidades de negocio activas.
   * Legacy: FilterUnidadNegocioViewImpl sin filtros
   */
  abstract listarTodas(
    cursor: string | null,
    size: number,
    direction: DireccionUnidadNegocio
  ): Promise<PageResponse<UnidadNegocio>>;

  /**
   * Busca unidades de negocio por código y/o nombre.
   * Legacy: FilterUnidadNegocioViewImpl con filtros tbCodigo y tbNombre
   *
   * @param codigo Código (nmconsecutivo) parcial (opcional)
   * @param nombre Nombre parcial de la unidad (opcional)
   */
  abstract buscar(
    codigo: string | undefined,
    nombre: string | undefined,
    cursor: string | null,
    size: number,
    direction: DireccionUnidadNegocio
  ): Promise<PageResponse<UnidadNegocio>>;
}
